export default "__VITE_ASSET__CgpdxH2i__"